import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { firstTruthy } from '@shared/rxjs-operators';
import { StartPageVersion } from '@shared/types';
import { catchError, map, of, throwError, timeout } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { ErrorPageReasons } from '../shared/constants';

export const startPageCanMatchFn = (startPageVersion: StartPageVersion): CanMatchFn => {
    return () => {
        const router = inject(Router);
        const configService = inject(ConfigService);

        return configService.configObs.pipe(
            firstTruthy(),
            timeout({
                each: 10_000,
                with: () => throwError(() => new Error(`Timeout while waiting for frontend config`)),
            }),
            map(({ portal }) => portal.startPageVersion === startPageVersion),
            catchError(() => {
                const navigationTargetUrl = router.getCurrentNavigation()?.extractedUrl.toString() || '/';

                return of(
                    router.createUrlTree(['error'], {
                        queryParams: {
                            reason: ErrorPageReasons.CustomMessage,
                            msg: 'Die Konfiguration konnte nicht geladen werden.',
                            redirect: navigationTargetUrl,
                        },
                    }),
                );
            }),
        );
    };
};
